// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Database, BarChart3, Pencil } from "lucide-react";

const ApiConfigurationCard = ({ api, onEdit }) => {
  const getIcon = (type) => {
    if (type === "crm") {
      return <Database className="w-5 h-5 text-blue-600 dark:text-blue-400" />;
    } else if (type === "analytics") {
      return (
        <BarChart3 className="w-5 h-5 text-green-600 dark:text-green-400" />
      );
    } else {
      return <Database className="w-5 h-5 text-blue-600 dark:text-blue-400" />;
    }
  };

  const getIconBg = (type) => {
    if (type === "crm") {
      return "bg-blue-100 dark:bg-blue-900/30";
    } else if (type === "analytics") {
      return "bg-green-100 dark:bg-green-900/30";
    } else {
      return "bg-blue-100 dark:bg-blue-900/30";
    }
  };

  const getDescription = (type) => {
    if (type === "crm") {
      return "Zahlungsabwicklung";
    } else if (type === "analytics") {
      return "Kundendaten synchronisieren";
    } else {
      return "API Integration";
    }
  };

  return (
    <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className={`p-2 ${getIconBg(api.type || "custom")} rounded-lg`}>
            {getIcon(api.type || "custom")}
          </div>
          <div>
            <h4 className="font-medium text-slate-900 dark:text-slate-100">
              {api.call_name}
            </h4>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              {getDescription(api.type || "custom")}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span
            className={`px-2 py-1 text-xs font-medium rounded-full ${
              api.is_enabled
                ? "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200"
                : "bg-gray-100 dark:bg-slate-600 text-gray-800 dark:text-slate-300"
            }`}
          >
            {api.is_enabled ? "Aktiv" : "Inaktiv"}
          </span>
          <button
            className="p-1 text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300"
            onClick={() => onEdit(api)}
          >
            <Pencil className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span className="text-slate-500 dark:text-slate-400">URL:</span>
          <span className="ml-2 font-mono text-xs text-slate-700 dark:text-slate-300">
            {api.endpoint_url}
          </span>
        </div>
        <div>
          <span className="text-slate-500 dark:text-slate-400">Methode:</span>
          <span className="ml-2 font-medium text-slate-900 dark:text-slate-200">
            {api.http_method}
          </span>
        </div>
        <div>
          <span className="text-slate-500 dark:text-slate-400">Timeout:</span>
          <span className="ml-2 font-medium text-slate-900 dark:text-slate-200">
            {api.timeout_seconds}s
          </span>
        </div>
        <div>
          <span className="text-slate-500 dark:text-slate-400">Status:</span>
          <span className="ml-2 font-medium text-green-600 dark:text-green-400">
            Erfolgreich
          </span>
        </div>
      </div>
    </div>
  );
};

export default ApiConfigurationCard;
